<template>

	<div class="pb--4" @click.stop.prevent="handleClick">
		<div class="accordion bdr--light-gray accordion--arrows">
			<div class="accordion__item bdr__top--light-gray" data-accordion-type="default"
				v-for="(acc, index) in accordions" :key="acc.title">
				<button :class="{ 'accordion__header--active': acc.display }" :id="'acc' + index"
					@click="acc.display = !acc.display" class="accordion__header txt--md txt--strong">
					{{ acc.title }}
				</button>
				<div :id="'acc-content' + index" class="accordion__content wysiwyg"
					:aria-labelledby="'acc' + index"
					:class="{ 'accordion__content--active active': acc.display }" v-html="acc.content"></div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	name: "Content",
	methods: {
		handleClick(e) {
			if (e.target.matches("a")) {
				let url = e.target.href;
				let target = e.target.target == "_blank" ? "_blank" : "_self";
				let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
				var isnativeapp = document.getElementById("isnativeapp");
				if (isnativeapp === undefined || isnativeapp === null) {
					window.open(url, target);
				}
				else {
					if (target == "_blank") {
						let data = { title: '', nodeid: dataId, href: url, target: target };
						window.Native('dataCallback', data);
					}
				}
			}
		},
	},
	data: function () {
		return {
			accordions: [
				{
					display: false,
					title: "Guidance",
					content: `
						<p><a href="https://www.sign.ac.uk/media/1766/sign-160-uti-0-1_web-version.pdf" target="_blank"><strong>SIGN guideline 160 (2020)</strong></a>: Management of suspected bacterial lower urinary tract infection in adult women</p>
					`
				}, {
					display: false,
					title: "Patient information & self-management resources",
					content: `
						<p>SIGN booklet for patients, carers and families: <a href="https://www.sign.ac.uk/media/1879/pat160-uti-patient-booklet.pdf">Managing suspected lower urinary tract infection (UTI) in adult women</a></p>
						<p><a href="https://www.sign.ac.uk/media/1766/sign-160-uti-0-1_web-version.pdf" target="_blank"><strong>SIGN 160</strong></a> recommends the following sources of patient/service user information:</p>
						<p><a href="http://bladderhealthuk.org/cystitis-utis-fowlerssyndrome" target="_blank"><strong>Bladder Health</strong></a></p>
						<p>Bladder Health UK gives support to people with all forms of cystitis, overactive bladder and continence issues together with their families and friends.</p>
						<p><a href="http://www.baus.org.uk/patients/conditions/14/urinary_infection_a" target="_blank"><strong>British Association of Urological Surgeons</strong></a></p>
						<p>The British Association of Urological Surgeons is a registered charity which promotes the highest standards of practice in urology, for the benefit of patients.</p>
						<p><a href="http://www.cobfoundation.org/bacterial-cystitis" target="_blank"><strong>The Cystitis & Overactive Bladder Foundation</strong></a></p>
						<p>The Cystitis and Overactive Bladder Foundation is the largest bladder patient support charity in the UK. It gives support to people with all forms of cystitis, overactive bladder and continence issues together with their families and friends. </p>
						<p><a href="http://www.nhs.uk/conditions/urinary-tract-infections-utis" target="_blank"><strong>NHS UK</strong></a></p>
						<p>The NHS website is the UK's biggest health website and contains thousands of freely available articles, videos, tools and apps to help people make the best choices about their health and wellbeing.</p>
						<p><a href="http://www.nhsinform.scot/illnesses-and-conditions/kidneys-bladder-and-prostate/urinary-tractinfection-uti" target="_blank"><strong>NHS Inform</strong></a></p>
						<p>NHS Inform is a patient access website providing health advice across a wide range of topics.</p>
						<p><a href="http://patient.info/womens-health/lower-urinary-tract-symptoms-in-women-luts/cystitis-in-women" target="_blank"><strong>Patient</strong></a></p>
						<p>Patient is a health information website which contains patient advice reviewed by doctors and other health professionals.</p>
					`
				},
				{
					display: true,
					title: "Regulatory Information",
					content: `
						<p>
						<strong>Product Name: </strong>Calculator Suite <br>
						<strong>Calculator Name: </strong><span id="calculator-name">Diagnosis and management of lower urinary tract infection in women under 65 years</span><br>
						<strong>Calculator Version: </strong> v2.1.0
						</p>  
						<div class="row">
						<div class="col-xs-4 col-lg-2">
							<img src="/img/cemark/shii.png" alt="InnoScot Health"/>
						</div>
						<div class="col-xs-8 col-lg-10">
							<p id="address">
                  Innoscot Health<br>
									Suite 23, The Pentagon Centre<br>
									36 Washington Street<br>
									Glasgow<br>
									G3 8AZ
                </p>
						</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<p>
								<img src="/img/cemark/ukca.png" alt="UK Conformity Assessed"/>
								<!-- <img src="/img/cemark/ce.png" alt="CE marking"/> -->
								</p>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-4 col-lg-2">
								<img src="/img/cemark/warning.png" alt="InnoScot Health"/>
							</div>
							<div class="col-xs-8 col-lg-10">
								<p>
								<strong>Calculators are <u>not</u> intended to be used by members of the public as a substitute for professional advice.</strong>
								</p>
							</div>
						</div>
						
						<div class="row">
							<div class="col-xs-4 col-lg-2">
								<img src="/img/cemark/info.png" alt="More Information on Right Decision"/>
							</div>
							<div class="col-xs-8 col-lg-10">
								<p>
									<a id="instructions" href="https://rightdecision.scot.nhs.uk/quality-assurance-and-regulation/calculator-suite-instructions-for-use.pdf" target="_blank">Instructions for use</a>
								</p>
							</div>
						</div>
					`
				}
			]
		}
	}
};
</script>
